<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :canAddNew="!canAdd"
      :items="items"
      search_route="/permissions/add"
      :search_title="$t('breadcrumb.permissions.add')"
      icon="fa-plus"
    />
    <!-- End Breadcrumb -->

    <!-- Start Main Section -->
    <main class="magic-table-wrapper">
      <v-data-table
        :headers="headers"
        :items="rows"
        :search="search"
        :loading="loading"
        :loading-text="$t('table.loadingData')"
        item-key="id"
        :expanded.sync="expanded"
        :items-per-page="rows.length"
        hide-default-footer
        class="thumb strip"
      >
        <!-- ================== You Can use any slots you want ================== -->
        <!-- Select no data State -->
        <template v-slot:no-data>
          {{ $t("table.noData") }}
        </template>
        <template v-slot:[`item.permission_category`]="{ item }">
          <span>{{ item[$i18n.locale].name }}</span>
        </template>
        <template v-slot:[`item.icon`]="{ item }">
          <span v-if="item.icon"><i :class="item.icon"></i> </span>
          <span class="redColor fontBold" v-else>لا يوجد ايقونة</span>
        </template>
        <template v-slot:[`item.show_in_side_bar`]="{ item }">
          <span :class="item.show_in_side_bar ? 'active' : 'inactive'">{{
            item.show_in_side_bar
              ? $t("forms.labels.is_side_show")
              : `عدم ${$t("forms.labels.is_side_show")}`
          }}</span>
        </template>
        <template v-slot:[`item.is_control_permission`]="{ item }">
          <span
            :class="item.is_control_permission ? 'active' : 'inactive'"
            title="امكانية التحكم في التفعيل والحظر ... الخ"
            >{{
              item.is_control_permission
                ? $t("forms.labels.is_control_permissions")
                : `عدم ${$t("forms.labels.is_control_permissions")}`
            }}</span
          >
        </template>
        <template v-slot:[`item.extendIcon`]="{ item }">
          <div class="_actions">
            <a role="button" @click="clickRow(item)">
              <span class="me-2"> عرض الصلاحيات </span>
              <i class="show fas fa-angle-double-down" small> </i>
            </a>
          </div>
        </template>
        <template v-slot:expanded-item="{ headers }">
          <td :colspan="headers.length" class="expandDate fadeIn">
            <span class="expandTitle">المزيد من التفاصيل</span>
            <v-data-table
              :headers="permissionRowHeaders"
              :items="expandData"
              item-key="id"
              hide-default-header
              hide-default-footer
              class="thumb strip"
            >
              <!-- ================== You Can use any slots you want ================== -->
              <!-- Select no data State -->
              <template v-slot:no-data>
                {{ $t("table.noData") }}
              </template>
              <template v-slot:[`item.icon`]="{ item }">
                <span v-if="item.icon"><i :class="item.icon"></i> </span>
                <span class="redColor fontBold" v-else>لا يوجد ايقونة</span>
              </template>
              <template v-slot:[`item.show_in_side_bar`]="{ item }">
                <span :class="item.show_in_side_bar ? 'active' : 'inactive'">{{
                  item.show_in_side_bar
                    ? $t("forms.labels.is_side_show")
                    : `عدم ${$t("forms.labels.is_side_show")}`
                }}</span>
              </template>
              <template v-slot:[`item.is_control_permission`]="{ item }">
                <span
                  :class="item.is_control_permission ? 'active' : 'inactive'"
                  title="امكانية التحكم في التفعيل والحظر ... الخ"
                  >{{
                    item.is_control_permission
                      ? $t("forms.labels.is_control_permissions")
                      : `عدم ${$t("forms.labels.is_control_permissions")}`
                  }}</span
                >
              </template>
              <!-- Select actions-->
              <template v-slot:[`item.actions`]="{ item }">
                <div class="_actions">
                  <v-icon
                    class="edit"
                    v-if="!canEdit"
                    small
                    @click="editItem(item)"
                  >
                    fal fa-edit
                  </v-icon>
                  <v-icon class="delete" small @click="deleteItem(item)">
                    fal fa-trash
                  </v-icon>
                </div>
              </template>
              <!-- ======================== Start Top Section ======================== -->

              <!-- ======================== End Top Section ======================== -->
            </v-data-table>
          </td>
        </template>

        <!-- ======================== Start Top Section ======================== -->
        <template v-slot:top>
          <h3 class="table-title title">
            الصلاحيات
            <span class="total">({{ rows.length }})</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  far fa-info-circle
                </v-icon>
              </template>
              <span>Tooltip</span>
            </v-tooltip>
          </h3>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("table.deletedialog.areYouSure") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="deleteItemConfirm">
                  {{ $t("table.deletedialog.ok") }}
                </v-btn>
                <v-btn color="#F44336" @click="dialogDelete = false">
                  {{ $t("table.deletedialog.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <!-- ======================== End Top Section ======================== -->
      </v-data-table>
    </main>
    <!-- End Main Section -->

    <!-- Start Pagination -->
    <template>
      <div
        class="pagination_container text-center mb-5 d-flex justify-content-end"
      >
        <v-pagination
          color="primary"
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="5"
          @input="fetchData($event)"
        ></v-pagination>
      </div>
    </template>
    <!-- End Pagination -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.permissions.title"),
          disabled: false,
          href: "/permissions/show-all",
        },
        {
          text: this.$t("breadcrumb.permissions.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Top Section
      search: "",
      dialogDelete: false,
      itemtoDelete: null,
      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      noExpand: false,

      // ========== Your Data
      rows: [], // injected in created
      expanded: [],
      expandData: [],
      // ========== Loding
      loading: false,
      headers: [
        {
          text: this.$t("labels.category"),
          align: "center",
          value: "permission_category",
          sortable: false,
        },

        {
          text: "المزيد",
          value: "extendIcon",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.icon"),
          value: "icon",
          align: "center",
        },
      ],
      permissionRowHeaders: [
        {
          text: this.$t("labels.title") + this.$t("inArabic"),
          align: "center",
          value: "ar.title",
          sortable: false,
        },
        {
          text: this.$t("labels.title") + this.$t("inEnglish"),
          align: "center",
          value: "en.title",
          sortable: false,
        },
        {
          text: this.$t("labels.is_side_show"),
          value: "show_in_side_bar",
          align: "center",
        },
        {
          text: this.$t("labels.is_control_permissions"),
          value: "is_control_permission",
          align: "center",
        },
        {
          text: this.$t("labels.icon"),
          value: "icon",
          align: "center",
        },
        {
          text: this.$t("labels.control"),
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 2,
        items_per_page: 20,
      },
      mapItem(data) {
        this.expandData = data.permissions;
      },
      clickRow(rowData) {
        if (this.noExpand) return;
        const indexExpanded = this.expanded.findIndex((i) => i === rowData);
        if (indexExpanded > -1) {
          // Exisit
          this.expanded.splice(indexExpanded, 1);
        } else {
          this.expanded = [];
          this.expanded.push(rowData);
          this.mapItem(rowData);
          // this.expandData = rowData
        }
      },
    };
  },

  watch: {
    [`$route`]() {
      if (this.$route.query.page) {
        this.paginations.current_page = +this.$route.query.page;
        this.setRows();
      } else {
        this.paginations.current_page = 1;
        this.setRows();
      }
    },
  },

  methods: {
    fetchData(e) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: e }),
      });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.setRows();
    },

    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
    refresh() {
      this.setRows();
    },
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/permissions/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/permissions/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/permissions/edit/" + item.id });
    },
    // ===== Delete
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `permission/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
          this.setRows();
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "permission",
        params: { page: this.paginations.current_page },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta?.last_page;
          this.paginations.items_per_page = res.data.meta?.per_page;
          this.total = res.data.meta?.total;
          this.rows = res.data.data;

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let message =
            err.response?.data.message ?? err.response?.data.messages;
          this.$iziToast.error({
            title: this.$t("validation.error"),
            message: message,
          });
        });
    },
  },

  // ======= hooks
  created() {
    this.canEdit = this.$permission.allowed("permissions/edit/");
    this.canDelete = this.$permission.allowed("permissions/delete");
    this.canAdd = this.$permission.allowed("permissions/add");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    // Set Rows
    this.setRows();
  },
};
</script>

<style lang="scss"></style>
